<template>
  <div>
    <wc-data-box
      title='Site'
      :titleIcon='$store.state.icons.dataBox.address.icon'
      :titleIconColor='$store.state.icons.dataBox.address.iconColor'
      showEdit
      @edit='edit'
    >
      <wc-two-column-table :items='tableData'></wc-two-column-table>
    </wc-data-box>

    <wc-dialog
      :showDialog='showDialog'
      :loadingButtons='isLoading'
      :disableButtons='!isFormValid'
      title='Site'
      :icon='$store.state.icons.dataBox.address.icon'
      width='400'
      @cancel='showDialog = false'
      @save='save'
    >
      <v-form v-model='isFormValid'>
        <v-text-field
          label='Address'
          v-model='inquiryCopy.site_address'
          :rules='[rules.required]'
        ></v-text-field>
        <v-text-field
          label='City'
          v-model='inquiryCopy.site_city'
        ></v-text-field>
      </v-form>
    </wc-dialog>

  </div>
</template>

<script>
import _ from 'lodash'
import formRules from '@/mixins/formRules'

export default {
  name: 'inquiry-site',
  mixins: [formRules],
  data: () => ({
    showDialog: false,
    isFormValid: false,
    isLoading: false,
    saving: false,
    inquiryCopy: {}
  }),
  props: {
    inquiry: {
      required: true
    }
  },
  computed: {
    tableData () {
      let data = []
      if (this.inquiry) {
        data = [
          { text: 'Address', value: this.inquiry.site_address },
          { text: 'City', value: this.inquiry.site_city }
        ]
      }
      return data
    }
  },
  methods: {
    edit () {
      this.inquiryCopy = _.cloneDeep(this.inquiry)
      this.showDialog = true
    },
    save () {
      this.$emit('update', this.inquiryCopy)
      this.showDialog = false
    }
  }
}
</script>
